import bolanos from "../assets/profilleDoctors/drBolanos.avif";
import tabush from "../assets/profilleDoctors/drTabush.avif";
import milagros from "../assets/profilleDoctors/draMilagrosG.avif";
import pablo from "../assets/profilleDoctors/drPabloS.avif";
import eugenia from "../assets/profilleDoctors/draEugeniaC.avif";
import emporio from "../assets/profilleDoctors/clinicaEmporio.avif";
import jery from "../assets/profilleDoctors/draJeryV.avif";
import friga from "../assets/profilleDoctors/draFrigaB.avif";
import mariana from "../assets/profilleDoctors/draMarianaH.avif";
import natalia from "../assets/profilleDoctors/draNataliaC.avif";
import guille from "../assets/profilleDoctors/drGuilleC.avif";
import diana from "../assets/profilleDoctors/draDianaC.avif";
import jaghna from "../assets/profilleDoctors/draJaghnaC.avif";
import loretta from "../assets/profilleDoctors/draLorettaP.avif";
import angela from "../assets/profilleDoctors/draAngelaV.avif";
import vilma from "../assets/profilleDoctors/draVilmaS.avif";
import monica from "../assets/profilleDoctors/draMonicaC.avif";
import laura from "../assets/profilleDoctors/draLauraO.avif";
import carlos from "../assets/profilleDoctors/drCarlosB.avif";
import edward from "../assets/profilleDoctors/drEdwardC.avif";
import gabriela from "../assets/profilleDoctors/draGabrielaP.avif";
import marisol from "../assets/profilleDoctors/draMarisolP.avif";
import isabel from "../assets/profilleDoctors/draIsabelM.avif";
import madeline from "../assets/profilleDoctors/draMadelineE.avif";
import heylin from "../assets/profilleDoctors/draHeylinM.avif";
import christian from "../assets/profilleDoctors/drChristianR.avif";
import daniela from "../assets/profilleDoctors/draDanielaV.avif";
import carolina from "../assets/profilleDoctors/draCarolinaP.avif";
import suzanne from "../assets/profilleDoctors/draSuzanneP.avif";
import stephanie from "../assets/profilleDoctors/draStephanieA.avif";
import monicaA from "../assets/profilleDoctors/draMonicaA.avif";
import madelein from "../assets/profilleDoctors/draMadeleinC.avif";
import analucia from "../assets/profilleDoctors/draAnaluciaP.avif";
import juanjose from "../assets/profilleDoctors/drJuanjoseH.avif";
import eugeniaP from "../assets/profilleDoctors/draEugeniaP.avif";
import gabrielaA from "../assets/profilleDoctors/draGabrielaA.avif";
import vladimir from "../assets/profilleDoctors/drVladimirM.avif";
import vivian from "../assets/profilleDoctors/draVivianC.avif";
import doctor from "../assets/profilleDoctors/doctor.avif";
import iturriaga from "../assets/profilleDoctors/drsIturriaga.avif";
import katherine from "../assets/profilleDoctors/draKatherineC.avif";
import chengi from "../assets/profilleDoctors/draChengiC.avif";
import maria from "../assets/profilleDoctors/draMariaJ.avif";
import adrian from "../assets/profilleDoctors/drAdrianG.avif";
import francisco from "../assets/profilleDoctors/drFranciscoC.avif";
import esmeralda from "../assets/profilleDoctors/draEsmeraldaR.avif";
import karol from "../assets/profilleDoctors/draKarolA.avif";
import vanessa from "../assets/profilleDoctors/draVanessaF.avif";
import samantha from "../assets/profilleDoctors/draSamanthaN.avif";
import alexander from "../assets/profilleDoctors/drAlexanderR.avif";
import roberto from "../assets/profilleDoctors/drRobertoG.avif";
import michelle from "../assets/profilleDoctors/draMichelleM.avif";
import monicaB from "../assets/profilleDoctors/draMonicaB.avif";
import hidalgo from "../assets/profilleDoctors/drsHidalgo.avif";
import cristhian from "../assets/profilleDoctors/drCristhianA.avif";
import mariela from "../assets/profilleDoctors/draMarielaC.avif";
import olga from "../assets/profilleDoctors/draOlgaR.avif";
import tatiana from "../assets/profilleDoctors/draTatianaC.avif";
import marcela from "../assets/profilleDoctors/draMarcelaM.avif";
import miguel from "../assets/profilleDoctors/drMiguelC.avif";
import catalina from "../assets/profilleDoctors/draCatalinaA.avif";
import nekisha from "../assets/profilleDoctors/draNekishaC.avif";
import luis from "../assets/profilleDoctors/drLuisS.avif";
import andresZ from "../assets/profilleDoctors/drAndresZ.avif";
import robertoV from "../assets/profilleDoctors/drRobertoV.avif";
import herin from "../assets/profilleDoctors/draHerinR.avif";
import katherineF from "../assets/profilleDoctors/draKatherineF.avif";

export const medicos = [
//RIGENERA
  {
    id: 1,
    nombre: "Dr. Armando Bolaños",
    lugar: "San Pablo, Heredia",
    direccion: "Clínica Dr. Bolaños León",
    telefono: "+506 8828-0588",
    whatsapp: "https://wa.me/50688280588",
    instagram: "https://www.instagram.com/dr.bolanos.leon",
    foto: bolanos,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 2,
    nombre: "Dr. José Tabush",
    lugar: "Avenida Escazú, Escazú",
    direccion: "Tabush Desmatología Laser Spa",
    telefono: "+506 2588-2987",
    whatsapp: "https://wa.me/50625882987",
    instagram: "https://instagram.com/tabush_dermatologia",
    foto: tabush,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 3,
    nombre: "Dra. Milagros González",
    lugar: "Plaza Montescazú, Escazú",
    direccion: "Regenerate Clinic",
    telefono: "+506 8754-7798",
    whatsapp: "https://wa.me/50687547798",
    instagram: "https://www.instagram.com/regenerate.clinic/",
    foto: milagros,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 4,
    nombre: "Dr. Pablo Sibaja",
    lugar: "Santa Ana, Costa Rica",
    direccion: "Mount Medical",
    telefono: "+506 7153-1058",
    whatsapp: "https://wa.me/50671531058",
    instagram: "https://www.instagram.com/drpablosibajar/",
    foto: pablo,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 5,
    nombre: "Dra. Eugenia Cuesta",
    lugar: "San Antonio de Belén, Heredia",
    direccion: "Soluciones Médicas Estéticas",
    telefono: "+506 8856-6557",
    whatsapp: "https://wa.me/50688566557",
    instagram: "https://www.instagram.com/draeugeniacuesta/",
    foto: eugenia,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 6,
    nombre: "Clínica Emporio",
    lugar: "Dulce Nombre, Coronado",
    direccion: "Clínica Emporio",
    telefono: "+506 7225-9912",
    whatsapp: "https://wa.me/50672259912",
    instagram: "https://www.instagram.com/emporiobellezaintegral/",
    foto: emporio,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 7,
    nombre: "Dra. Jery Villalobos",
    lugar: "Centro Médico Momentum Escazú",
    direccion: "Hair Philosophy Clinic",
    telefono: "+506 8988-4152",
    whatsapp: "https://wa.me/50689884152",
    instagram: "https://instagram.com/hairphilosophyclinic/",
    foto: jery,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 8,
    nombre: "Dra. Friga Brizuela",
    lugar: "San José | Playas del Coco |Quepos",
    direccion: "LUSH Dermatology & Hair Clinic",
    telefono: "+506 2221-4446",
    whatsapp: "https://wa.me/50622214446",
    instagram: "https://www.instagram.com/lush_dermatology/",
    foto: friga,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 9,
    nombre: "Dra. Mariana Molina",
    lugar: "Cartago, Costa Rica",
    direccion: "The Healing Center",
    telefono: "+506 6057-4359",
    whatsapp: "https://wa.me/50660574359",
    instagram: "https://www.instagram.com/the_healingcenter_/",
    foto: mariana,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 10,
    nombre: "Dra. Natalia Chacón",
    lugar: "Plaza Real Alajuela",
    direccion: "Dra. Natalia Chacón Medicina General y Estética",
    telefono: "+506 8374-2143",
    whatsapp: "https://wa.me/50683742143",
    instagram: "https://instagram.com/dranataliachacon",
    foto: natalia,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 11,
    nombre: "Dr. Guillermo Cortés",
    lugar: "Cartago, Costa Rica",
    direccion: "Dermaláser",
    telefono: "+506 6029-9527",
    whatsapp: "https://wa.me/50660299527",
    instagram: "https://instagram.com/dermalasercostarica",
    foto: guille,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 12,
    nombre: "Dra. Laura Oliveros",
    lugar: "Oficentro Valar, Heredia",
    direccion: "Vitapiel Dermatología CR",
    telefono: "+506 7261-4743",
    whatsapp: "https://wa.me/50672614743",
    instagram: "https://instagram.com/vitapieldermatologiacr",
    foto: laura,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 13,
    nombre: "Dra. Diana Correa",
    lugar: "Santa Ana | Hospital La Católica",
    direccion: "Dra. Piel",
    telefono: "+506 6465-0496",
    whatsapp: "https://wa.me/50664650496",
    instagram: "https://www.instagram.com/drapielcr/",
    foto: diana,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 14,
    nombre: "Dra. Jaghna Cordero",
    lugar: "Plaza Real Alajuela",
    direccion: "Clínica Integral Cordero",
    telefono: "+506 7162-5609",
    whatsapp: "https://wa.me/50671625609",
    instagram: "https://www.instagram.com/clinicaintegralcordero/",
    foto: jaghna,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 15,
    nombre: "Dra. Loretta Piccolo",
    lugar: "Torre La Sabana, San José",
    direccion: "State of the Art",
    telefono: "+506 7188-1188",
    whatsapp: "https://wa.me/50671881188",
    instagram: "https://www.instagram.com/stateoftheartcr/",
    foto: loretta,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 16,
    nombre: "Dra. Ángela Vargas",
    lugar: "Sabana Norte, San José",
    direccion: "Centro Piel y Salud",
    telefono: "+506 8358-6375",
    whatsapp: "https://wa.me/50683586375",
    instagram: "https://www.instagram.com/centropielysalud_/",
    foto: angela,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 17,
    nombre: "Dra. Vilma Soto",
    lugar: "Tibás, San José",
    direccion: "Hospital UNIBE",
    telefono: "+506 2297-6300",
    whatsapp: "https://wa.me/50622976300",
    instagram: "",
    foto: vilma,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
  {
    id: 18,
    nombre: "Dra. Mónica Chávez",
    lugar: "Plaza Naos, Heredia",
    direccion: "Piel Viva Dermatológica",
    telefono: "+506 8659-4770",
    whatsapp: "https://wa.me/50686594770",
    instagram: "https://www.instagram.com/pielvivacr/",
    foto: monica,
    producto: "RIGENERA",
    tipo: "Tecnología",
  },
//SYLFIRMX
  {
    id: 19,
    nombre: "Dr. Carlos Bravo",
    lugar: "Barrio Otoya, San José",
    direccion: "Dermatología Integral",
    telefono: "+506 8728-0596",
    whatsapp: "https://wa.me/50687280596",
    instagram: "https://www.instagram.com/dermatologiaintegralcr/",
    foto: carlos,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 20,
    nombre: "Dr. Edward Castro",
    lugar: "Sabana Norte, San José",
    direccion: "Beyond Laser Skin Center",
    telefono: "+506 7133-6006",
    whatsapp: "https://wa.me/50671336006",
    instagram: "https://www.instagram.com/beyond.laserskincenter/",
    foto: edward,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 21,
    nombre: "Dra. Vilma Soto",
    lugar: "La Florida, Tibás",
    direccion: "Hospital UNIBE",
    telefono: "+506 8626-4707",
    whatsapp: "https://wa.me/50686264707",
    instagram: "https://www.instagram.com/hospital.unibe/",
    foto: vilma,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 22,
    nombre: "Dra. Gabriela Prado",
    lugar: "Curridabat, San José",
    direccion: "Cultura Piel",
    telefono: "+506 8585-6727",
    whatsapp: "https://wa.me/50685856727",
    instagram: "https://www.instagram.com/culturapiel/",
    foto: gabriela,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 23,
    nombre: "Dra. Jaghna Cordero",
    lugar: "Plaza Real Alajuela",
    direccion: "Clínica Integral Cordero",
    telefono: "+506 7162-5609",
    whatsapp: "https://wa.me/50671625609",
    instagram: "https://www.instagram.com/clinicaintegralcordero/",
    foto: jaghna,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 24,
    nombre: "Dra. Marisol Pedroso",
    lugar: "Liberia, Guanacaste",
    direccion: "SKIN Care Center",
    telefono: "+506 7086-1757",
    whatsapp: "https://wa.me/50670861757",
    instagram: "https://www.instagram.com/dra_pedroso_derma/",
    foto: marisol,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 25,
    nombre: "Dra. Isabel Morelli",
    lugar: "Torre Médica Momentum, Escazú",
    direccion: "IKIGAI",
    telefono: "+506 8650-9119",
    whatsapp: "https://wa.me/50686509119",
    instagram: "https://www.instagram.com/ikigai_by_draisamorelli/",
    foto: isabel,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
  {
    id: 26,
    nombre: "Dra. Madeline Espinoza",
    lugar: "Rohrmoser, San José",
    direccion: "Made For You Medical Beauty",
    telefono: "+506 6007-4169",
    whatsapp: "https://wa.me/50660074169",
    instagram: "https://www.instagram.com/mfymedicalbeauty/",
    foto: madeline,
    producto: "SYLFIRMX",
    tipo: "Tecnología",
  },
//EMERALD
  {
    id: 27,
    nombre: "Dr. Armando Bolaños",
    lugar: "San Pablo, Heredia",
    direccion: "Clínica Dr. Bolaños León",
    telefono: "+506 8828-0588",
    whatsapp: "https://wa.me/50688280588",
    instagram: "https://www.instagram.com/dr.bolanos.leon",
    foto: bolanos,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 28,
    nombre: "Dra. Heylin Montiel",
    lugar: "Guadalupe, San José",
    direccion: "Hospital La Católica",
    telefono: "+506 2260-1668",
    whatsapp: "https://wa.me/50622601668",
    instagram: "https://www.instagram.com/draheylin_montiel/",
    foto: heylin,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 29,
    nombre: "Dr. Christian Rivera",
    lugar: "San José, Costa Rica",
    direccion: "Clínica Rivera",
    telefono: "+506 6106-9069",
    whatsapp: "https://wa.me/50661069069",
    instagram: "https://www.instagram.com/clinica_riveracr/",
    foto: christian,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 30,
    nombre: "Dra. Daniela Vargas",
    lugar: "Escazú, San José",
    direccion: "The Clinic",
    telefono: "+506 8977-0528",
    whatsapp: "https://wa.me/50689770528",
    instagram: "https://www.instagram.com/the_clinic_cr/",
    foto: daniela,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 31,
    nombre: "Dra. Isabel Morelli",
    lugar: "Torre Médica Momentum, Escazú",
    direccion: "IKIGAI",
    telefono: "+506 8650-9119",
    whatsapp: "https://wa.me/50686509119",
    instagram: "https://www.instagram.com/ikigai_by_draisamorelli/",
    foto: isabel,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 32,
    nombre: "Dr. Pablo Sibaja",
    lugar: "Sabana Norte, San José",
    direccion: "Clínica Corazón de Jesús",
    telefono: "+506 7153-1058",
    whatsapp: "https://wa.me/50671531058",
    instagram: "https://www.instagram.com/drpablosibajar/",
    foto: pablo,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 33,
    nombre: "Dra. Carolina Pérez",
    lugar: "Heredia | Lindora",
    direccion: "CSI Clínica Salud Integral",
    telefono: "+506 6004-1234",
    whatsapp: "https://wa.me/50660041234",
    instagram: "https://www.instagram.com/csisaludintegral/",
    foto: carolina,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 34,
    nombre: "Dra. Karla Carballo",
    lugar: "Nunciatura, San José",
    direccion: "DRC Dra. Karla Carballo",
    telefono: "+506 6320-1368",
    whatsapp: "https://wa.me/50663201368",
    instagram: "https://www.instagram.com/drc_dra.karlacarballo/",
    foto: doctor,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 35,
    nombre: "Dra. Suzanne Perera",
    lugar: "Heredia Centro, Heredia",
    direccion: "Clínica Perera",
    telefono: "+506 2262-2222",
    whatsapp: "https://wa.me/50622622222",
    instagram: "https://www.instagram.com/clinica_drs_perera/",
    foto: suzanne,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 36,
    nombre: "Dra. Stephanie Acuña",
    lugar: "Curridabat, San José",
    direccion: "Clínica Breathe",
    telefono: "+506 6023-1924",
    whatsapp: "https://wa.me/50660231924",
    instagram: "https://www.instagram.com/dra.stephanieacuna/",
    foto: stephanie,
    producto: "EMERALD",
    tipo: "Tecnología",
  },
  {
    id: 37,
    nombre: "Dra. Madelein Centeno",
    lugar: "San José, San José",
    direccion: "Universal Plastic Surgery",
    telefono: "+506 2222-6441",
    whatsapp: "https://wa.me/50622226441",
    instagram: "https://www.instagram.com/universalplasticsurgery/",
    foto: madelein,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 38,
    nombre: "Dr. Carlos Bravo",
    lugar: "Barrio Otoya, San José",
    direccion: "Dermatología Integral",
    telefono: "+506 8728-0596",
    whatsapp: "https://wa.me/50687280596",
    instagram: "https://www.instagram.com/dermatologiaintegralcr/",
    foto: carlos,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 39,
    nombre: "Dra. Suzanne Perera",
    lugar: "Heredia Centro, Heredia",
    direccion: "Clínica Perera",
    telefono: "+506 2262-2222",
    whatsapp: "https://wa.me/50622622222",
    instagram: "https://www.instagram.com/clinica_drs_perera/",
    foto: suzanne,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 40,
    nombre: "Dra. Mónica Alfaro",
    lugar: "Ojochal, Costa Rica",
    direccion: "Bahía Ballena Doctors",
    telefono: "+506 8833-6431",
    whatsapp: "https://wa.me/50688336431",
    instagram: "https://www.facebook.com/monica.alfaroe",
    foto: monicaA,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 41,
    nombre: "Dr. Edward Castro",
    lugar: "Sabana Norte, San José",
    direccion: "Beyond Laser Skin Center",
    telefono: "+506 7133-6006",
    whatsapp: "https://wa.me/50671336006",
    instagram: "https://www.instagram.com/beyond.laserskincenter/",
    foto: edward,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 42,
    nombre: "Dra. Ana Lucía Pineda",
    lugar: "San José, San José",
    direccion: "Medibel Clinic",
    telefono: "+506 6395-5721",
    whatsapp: "https://wa.me/50663955721",
    instagram: "https://www.instagram.com/medibel_clinic/",
    foto: analucia,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 43,
    nombre: "Dr. Christian Rivera",
    lugar: "San José",
    direccion: "Clínica Rivera",
    telefono: "+506 6106-9069",
    whatsapp: "https://wa.me/50661069069",
    instagram: "https://www.instagram.com/clinica_riveracr/",
    foto: christian,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
  {
    id: 44,
    nombre: "Dr. Juan José Hernández",
    lugar: "Sabana Norte, San José",
    direccion: "FullFace Costa Rica",
    telefono: "+506 7032-1391",
    whatsapp: "https://wa.me/50670321391",
    instagram: "https://www.instagram.com/fullfacecostarica/",
    foto: juanjose,
    producto: "JOVENA",
    tipo: "Tecnología",
  },
//HYPER PULSE
  {
    id: 45,
    nombre: "Dra. Eugenia Paris",
    lugar: "Hospital CIMA",
    direccion: "Clínica de Terapia Física y Rehabilitación",
    telefono: "+506 2208-1365",
    whatsapp: "https://wa.me/50622081365",
    instagram: "https://www.instagram.com/cipcima/",
    foto: eugeniaP,
    producto: "HYPER PULSE",
    tipo: "Tecnología",
  },
  {
    id: 46,
    nombre: "Dra. Gabriela Alfaro",
    lugar: "Ciudad Quesada, San Carlos",
    direccion: "Alpha Skin&Body Experts",
    telefono: "+506 6065-4555",
    whatsapp: "https://wa.me/50660654555",
    instagram: "https://www.instagram.com/alpha.skinbodyexperts/",
    foto: gabrielaA,
    producto: "HYPER PULSE",
    tipo: "Tecnología",
  },
  {
    id: 47,
    nombre: "Dr. Vladimir Mata",
    lugar: "Playa Jacó, Puntarenas",
    direccion: "Clínica ALMA Medicina & Cirugía Estética",
    telefono: "+506 8388-2236",
    whatsapp: "https://wa.me/50683882236",
    instagram: "https://www.instagram.com/clinica_alma.jaco/",
    foto: vladimir,
    producto: "HYPER PULSE",
    tipo: "Tecnología",
  },
  {
    id: 48,
    nombre: "Dra. Vivian Campos",
    lugar: "Sabana Norte, San José",
    direccion: "Medicina Estética Dra. Vivi Campos",
    telefono: "+506 8373-6565",
    whatsapp: "https://wa.me/50683736565",
    instagram: "https://www.instagram.com/dra.vivicampos/",
    foto: vivian,
    producto: "HYPER PULSE",
    tipo: "Tecnología",
  },
  {
    id: 49,
    nombre: "Dra. Lineth Ramos",
    lugar: "Grecia, Alajuela",
    direccion: "Depiarte",
    telefono: "+506 8812-3340",
    whatsapp: "https://wa.me/50688123340",
    instagram: "https://www.instagram.com/depiartecr/",
    foto: doctor,
    producto: "HYPER PULSE",
    tipo: "Tecnología",
  },
  {
    id: 50,
    nombre: "Drs. Iturriaga",
    lugar: "Limón, Costa Rica",
    direccion: "Alma Esthetic Center",
    telefono: "+506 8774-5335",
    whatsapp: "https://wa.me/50687745335",
    instagram: "https://www.instagram.com/almaestheticcenter/",
    foto: iturriaga,
    producto: "HYPER PULSE",
    tipo: "Tecnología",
  },
//IMPERIUM MED 400
  {
    id: 51,
    nombre: "Dra. Eugenia Paris",
    lugar: "Hospital CIMA",
    direccion: "Clínica de Terapia Física y Rehabilitación",
    telefono: "+506 2208-1365",
    whatsapp: "https://wa.me/50622081365",
    instagram: "https://www.instagram.com/cipcima/",
    foto: eugeniaP,
    producto: "IMPERIUM MED 400",
    tipo: "Tecnología",
  },
  {
    id: 52,
    nombre: "Dra. Katherine Campbell",
    lugar: "Paseo Colón, San José",
    direccion: "Centro Médico Integral Campbell",
    telefono: "+506 8433-0279",
    whatsapp: "https://wa.me/50684330279",
    instagram: "https://www.instagram.com/centro_medico_campbell/",
    foto: katherine,
    producto: "IMPERIUM MED 400",
    tipo: "Tecnología",
  },
  {
    id: 53,
    nombre: "Dra. Chengi Chan",
    lugar: "San Joaquín, Heredia",
    direccion: "Mediclinic NyD",
    telefono: "+506 8684-6024",
    whatsapp: "https://wa.me/50686846024",
    instagram: "https://www.instagram.com/mediclinic_nyd/",
    foto: chengi,
    producto: "IMPERIUM MED 400",
    tipo: "Tecnología",
  },
  {
    id: 54,
    nombre: "Dra. María José Alfaro",
    lugar: "Fátima, Heredia",
    direccion: "Clínica Alfaro",
    telefono: "+506 8849-9545",
    whatsapp: "https://wa.me/50688499545",
    instagram: "https://www.instagram.com/clinicaalfarocr/",
    foto: maria,
    producto: "IMPERIUM MED 400",
    tipo: "Tecnología",
  },
  {
    id: 55,
    nombre: "Dra. Madelein Centeno",
    lugar: "San José, San José",
    direccion: "Universal Plastic Surgery",
    telefono: "+506 2222-6441",
    whatsapp: "https://wa.me/50622226441",
    instagram: "https://www.instagram.com/universalplasticsurgery/",
    foto: madelein,
    producto: "IMPERIUM MED 400",
    tipo: "Tecnología",
  },
  {
    id: 56,
    nombre: "Dra. Ángela Vargas",
    lugar: "Sabana Norte, San José",
    direccion: "Centro Piel y Salud",
    telefono: "+506 8358-6375",
    whatsapp: "https://wa.me/50683586375",
    instagram: "https://www.instagram.com/centropielysalud_/",
    foto: angela,
    producto: "IMPERIUM MED 400",
    tipo: "Tecnología",
  },
//BODYSTIM
  {
    id: 57,
    nombre: "Dr. Edward Castro",
    lugar: "Sabana Norte, San José",
    direccion: "Beyond Laser Skin Center",
    telefono: "+506 7133-6006",
    whatsapp: "https://wa.me/50671336006",
    instagram: "https://www.instagram.com/beyond.laserskincenter/",
    foto: edward,
    producto: "BODYSTIM",
    tipo: "Tecnología",
  },
  {
    id: 58,
    nombre: "Dra. Marisol Pedroso",
    lugar: "Liberia, Guanacaste",
    direccion: "SKIN Care Center",
    telefono: "+506 7086-1757",
    whatsapp: "https://wa.me/50670861757",
    instagram: "https://www.instagram.com/dra_pedroso_derma/",
    foto: marisol,
    producto: "BODYSTIM",
    tipo: "Tecnología",
  },
//ADVA
  {
    id: 59,
    nombre: "Dr. José Tabush",
    lugar: "Avenida Escazú, Escazú",
    direccion: "Tabush Desmatología Laser Spa",
    telefono: "+506 2588-2987",
    whatsapp: "https://wa.me/50625882987",
    instagram: "https://instagram.com/tabush_dermatologia",
    foto: tabush,
    producto: "ADVA",
    tipo: "Tecnología",
  },
  {
    id: 60,
    nombre: "Dra. Diana Correa",
    lugar: "Santa Ana | Hospital La Católica",
    direccion: "Dra. Piel",
    telefono: "+506 6465-0496",
    whatsapp: "https://wa.me/50664650496",
    instagram: "https://www.instagram.com/drapielcr/",
    foto: diana,
    producto: "ADVA",
    tipo: "Tecnología",
  },
  {
    id: 61,
    nombre: "Dra. Suzanne Perera",
    lugar: "Heredia Centro, Heredia",
    direccion: "Clínica Perera",
    telefono: "+506 2262-2222",
    whatsapp: "https://wa.me/50622622222",
    instagram: "https://www.instagram.com/clinica_drs_perera/",
    foto: suzanne,
    producto: "ADVA",
    tipo: "Tecnología",
  },
  {
    id: 62,
    nombre: "Dr. Adrián Gutiérrez",
    lugar: "Piso 2. Consultorio 9",
    direccion: "Hospital La Católica",
    telefono: "+506 2246-3000",
    whatsapp: "https://wa.me/50687205500",
    instagram: "https://www.instagram.com/clinica_drs_perera/",
    foto: adrian,
    producto: "ADVA",
    tipo: "Tecnología",
  },
//NEOGEN
  {
    id: 63,
    nombre: "Dr. José Tabush",
    lugar: "Avenida Escazú, Escazú",
    direccion: "Tabush Desmatología Laser Spa",
    telefono: "+506 2588-2987",
    whatsapp: "https://wa.me/50625882987",
    instagram: "https://instagram.com/tabush_dermatologia",
    foto: tabush,
    producto: "NEOGEN",
    tipo: "Tecnología",
  },
//ENYGMA
  {
    id: 64,
    nombre: "Dra. Ángela Vargas",
    lugar: "Sabana Norte, San José",
    direccion: "Centro Piel y Salud",
    telefono: "+506 8358-6375",
    whatsapp: "https://wa.me/50683586375",
    instagram: "https://www.instagram.com/centropielysalud_/",
    foto: angela,
    producto: "ENYGMA",
    tipo: "Tecnología",
  },
  {
    id: 65,
    nombre: "Drs. Iturriaga",
    lugar: "Limón, Costa Rica",
    direccion: "Alma Esthetic Center",
    telefono: "+506 8774-5335",
    whatsapp: "https://wa.me/50687745335",
    instagram: "https://www.instagram.com/almaestheticcenter/",
    foto: iturriaga,
    producto: "ENYGMA",
    tipo: "Tecnología",
  },
    {
    id: 66,
    nombre: "Dr. Francisco Córdoba",
    lugar: "Ciudad Quesada",
    direccion: " ",
    telefono: "+506 8992-8392",
    whatsapp: "https://wa.me/50689928392",
    instagram: "https://www.instagram.com/drcordobamoya/",
    foto: francisco,
    producto: "ENYGMA",
    tipo: "Tecnología",
  },
  {
    id: 65,
    nombre: "Dra. Esmeralda Rojas",
    lugar: " ",
    direccion: "Hospital La Católica",
    telefono: "+506 8384-3857",
    whatsapp: "https://wa.me/50683843857",
    instagram: "https://www.instagram.com/ginelasercrc/",
    foto: esmeralda,
    producto: "ENYGMA",
    tipo: "Tecnología",
  },
//CRYSTAL 3D PLUS
  {
    id: 66,
    nombre: "Dra. Karol Alfaro",
    lugar: "San Rafael de Escazú",
    direccion: "Kaderma Clínica Dermatológica",
    telefono: "+506 8329-4444",
    whatsapp: "https://wa.me/50683294444",
    instagram: "https://www.instagram.com/kadermatologa/",
    foto: karol,
    producto: "CRYSTAL 3D PLUS",
    tipo: "Tecnología",
  },
//TARGETCOOL
  {
    id: 67,
    nombre: "Dr. Armando Bolaños",
    lugar: "San Pablo, Heredia",
    direccion: "Clínica Dr. Bolaños León",
    telefono: "+506 8828-0588",
    whatsapp: "https://wa.me/50688280588",
    instagram: "https://www.instagram.com/dr.bolanos.leon",
    foto: bolanos,
    producto: "TARGETCOOL",
    tipo: "Tecnología",
  },
  {
    id: 68,
    nombre: "Dr. Edward Castro",
    lugar: "Sabana Norte, San José",
    direccion: "Beyond Laser Skin Center",
    telefono: "+506 7133-6006",
    whatsapp: "https://wa.me/50671336006",
    instagram: "https://www.instagram.com/beyond.laserskincenter/",
    foto: edward,
    producto: "TARGETCOOL",
    tipo: "Tecnología",
  },
//LAVIEEN
  {
    id: 69,
    nombre: "Dr. José Tabush",
    lugar: "Avenida Escazú, Escazú",
    direccion: "Tabush Desmatología Laser Spa",
    telefono: "+506 2588-2987",
    whatsapp: "https://wa.me/50625882987",
    instagram: "https://instagram.com/tabush_dermatologia",
    foto: tabush,
    producto: "LAVIEEN",
    tipo: "Tecnología",
  },
  {
    id: 70,
    nombre: "Dra. Vanessa Fumero",
    lugar: "Avenida Escazú, Escazú",
    direccion: "Fumero Skin & Dental Center",
    telefono: "+506 8357-1010",
    whatsapp: "https://wa.me/50683571010",
    instagram: "https://instagram.com/fumeroskincenteroficial",
    foto: vanessa,
    producto: "LAVIEEN",
    tipo: "Tecnología",
  },
  {
    id: 71,
    nombre: "Dra. Samantha Naranjo",
    lugar: "Torre Omega, Clínica Bíblica",
    direccion: "Dermatología Avanzada",
    telefono: "+506 6466-7012",
    whatsapp: "https://wa.me/50664667012",
    instagram: "https://instagram.com/dermaavanzada",
    foto: samantha,
    producto: "LAVIEEN",
    tipo: "Tecnología",
  },
//FX405
  {
    id: 72,
    nombre: "Dr. Pablo Sibaja",
    lugar: "Santa Ana, Costa Rica",
    direccion: "Mount Medical",
    telefono: "+506 7153-1058",
    whatsapp: "https://wa.me/50671531058",
    instagram: "https://www.instagram.com/drpablosibajar/",
    foto: pablo,
    producto: "FX405",
    tipo: "Tecnología",
  },
//GVL
  {
    id: 73,
    nombre: "Dr. Pablo Sibaja",
    lugar: "Santa Ana, Costa Rica",
    direccion: "Mount Medical",
    telefono: "+506 7153-1058",
    whatsapp: "https://wa.me/50671531058",
    instagram: "https://www.instagram.com/drpablosibajar/",
    foto: pablo,
    producto: "GVL",
    tipo: "Tecnología",
  },
//PLASMAGE
  {
    id: 74,
    nombre: "Dr. Alexander Rivera",
    lugar: "Plaza Fuentes del Obelisco, Escazú",
    direccion: "Mount Medical",
    telefono: "+506 2588-1115",
    whatsapp: "https://wa.me/50664341061",
    instagram: "https://www.instagram.com/dr_alexrivera/",
    foto: alexander,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 75,
    nombre: "Dr. Roberto Gamboa",
    lugar: "Alajuela",
    direccion: "SKIN CLUB",
    telefono: "+506 8769-3124",
    whatsapp: "https://wa.me/50687693124",
    instagram: "https://www.instagram.com/dermarobertogamboa/",
    foto: roberto,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 76,
    nombre: "Dra. Michelle Morejón",
    lugar: "San Pedro, San José",
    direccion: "MK Aesthetic",
    telefono: "+506 8704-2626",
    whatsapp: "https://wa.me/50687042626",
    instagram: "https://www.instagram.com/dra.morejon/",
    foto: michelle,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 77,
    nombre: "Dra. Mónica Banard",
    lugar: "Lindora, San José",
    direccion: "Banard Center Skin and Mental Health",
    telefono: "+506 6190-7317",
    whatsapp: "https://wa.me/50661907317",
    instagram: "https://www.instagram.com/dra.monica.banard/",
    foto: monicaB,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 78,
    nombre: "Drs. Hidalgo",
    lugar: "San Pedro, Montes de Oca",
    direccion: "Cenderma",
    telefono: "+506 8842-0244",
    whatsapp: "https://wa.me/50688420244",
    instagram: "https://www.instagram.com/cendermadrshidalgo/",
    foto: hidalgo,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 79,
    nombre: "Dr. Cristhian Alvarado",
    lugar: "Grecia | Escazú",
    direccion: "Dermatología Avanzada",
    telefono: "+506 8514-3666",
    whatsapp: "https://wa.me/50685143666",
    instagram: "https://www.instagram.com/drcristhian.derma/",
    foto: cristhian,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 80,
    nombre: "Dra. Friga Brizuela",
    lugar: "San José | Playas del Coco | Quepos",
    direccion: "LUSH Dermatology & Hair Clinic",
    telefono: "+506 2221-4446",
    whatsapp: "https://wa.me/50622214446",
    instagram: "https://www.instagram.com/lush_dermatology/",
    foto: friga,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 81,
    nombre: "Dra. Samantha Naranjo",
    lugar: "Torre Omega, Clínica Bíblica",
    direccion: "Dermatología Avanzada",
    telefono: "+506 6466-7012",
    whatsapp: "https://wa.me/50664667012",
    instagram: "https://www.instagram.com/dermaavanzada/",
    foto: samantha,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 82,
    nombre: "Dra. Mariela Campos",
    lugar: "Pinares, Curridabat",
    direccion: "Dermatología Avanzada",
    telefono: "+506 8885-3861",
    whatsapp: "https://wa.me/50688853861",
    instagram: "https://www.instagram.com/dra.marielacampos/",
    foto: mariela,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
  {
    id: 83,
    nombre: "Dra. Olga Rodríguez",
    lugar: "San Pablo de Heredia",
    direccion: "Clínica Médica Roch",
    telefono: "+506 8561-8822",
    whatsapp: "https://wa.me/50685618822",
    instagram: "https://www.instagram.com/clinica_dra_olga_rodriguez/",
    foto: olga,
    producto: "PLASMAGE",
    tipo: "Tecnología",
  },
//HEBE
  {
    id: 84,
    nombre: "Dra. Tatiana Campbell",
    lugar: "Escazú, San José",
    direccion: "Kairos Aesthetic and Pro-aging Clinic",
    telefono: "+506 7084-5471",
    whatsapp: "https://wa.me/50670845471",
    instagram: "https://www.instagram.com/kairos.aesthetics.cr/",
    foto: tatiana,
    producto: "HEBE",
    tipo: "Tecnología",
  },
//MELINE
  {
    id: 84,
    nombre: "Dra. Gabriela Prado",
    lugar: "Curridabat, San José",
    direccion: "Cultura Piel",
    telefono: "+506 8585-6727",
    whatsapp: "https://wa.me/50685856727",
    instagram: "https://www.instagram.com/culturapiel/",
    foto: gabriela,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 85,
    nombre: "Dr. José Tabush",
    lugar: "Avenida Escazú, Escazú",
    direccion: "Tabush Desmatología Laser Spa",
    telefono: "+506 2588-2987",
    whatsapp: "https://wa.me/50625882987",
    instagram: "https://instagram.com/tabush_dermatologia",
    foto: tabush,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 86,
    nombre: "Dra. Ángela Vargas",
    lugar: "Sabana Norte, San José",
    direccion: "Centro Piel y Salud",
    telefono: "+506 8358-6375",
    whatsapp: "https://wa.me/50683586375",
    instagram: "https://www.instagram.com/centropielysalud_/",
    foto: angela,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 87,
    nombre: "Dr. Edward Castro",
    lugar: "Sabana Norte, San José",
    direccion: "Beyond Laser Skin Center",
    telefono: "+506 7133-6006",
    whatsapp: "https://wa.me/50671336006",
    instagram: "https://www.instagram.com/beyond.laserskincenter/",
    foto: edward,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 88,
    nombre: "Drs. Hidalgo",
    lugar: "San Pedro, Montes de Oca",
    direccion: "Cenderma",
    telefono: "+506 8842-0244",
    whatsapp: "https://wa.me/50688420244",
    instagram: "https://www.instagram.com/cendermadrshidalgo/",
    foto: hidalgo,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 89,
    nombre: "Dr. Armando Bolaños",
    lugar: "San Pablo, Heredia",
    direccion: "Clínica Dr. Bolaños León",
    telefono: "+506 8828-0588",
    whatsapp: "https://wa.me/50688280588",
    instagram: "https://www.instagram.com/dr.bolanos.leon",
    foto: bolanos,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 90,
    nombre: "Dra. Stephanie Acuña",
    lugar: "Curridabat, San José",
    direccion: "Clínica Breathe",
    telefono: "+506 6023-1924",
    whatsapp: "https://wa.me/50660231924",
    instagram: "https://www.instagram.com/dra.stephanieacuna/",
    foto: stephanie,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 91,
    nombre: "Dra. Johania Ruíz",
    lugar: "Plaza Villa Columbus, Ciudad Colón",
    direccion: "Hifucr Salud Belleza",
    telefono: "+506 7109-4466",
    whatsapp: "https://wa.me/50671094466",
    instagram: "https://www.instagram.com/hifucr_salud_belleza/",
    foto: doctor,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 92,
    nombre: "Dra. Adriana Vargas Rodríguez",
    lugar: "Curridabat",
    direccion: "DermaMedic | Clínica Zahha",
    telefono: "+506 6415-4953",
    whatsapp: "https://wa.me/50664154953",
    instagram: "https://www.instagram.com/dermamediccr/",
    foto: doctor,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 93,
    nombre: "Dra. Marcela Monge",
    lugar: "Curridabat",
    direccion: "Consultorio Dra. Marcela Monge",
    telefono: "+506 7073-2858",
    whatsapp: "https://wa.me/50670732858",
    instagram: "https://www.instagram.com/dra.marcelamongefernandez/",
    foto: marcela,
    producto: "MELINE",
    tipo: "Insumo",
  },
  {
    id: 94,
    nombre: "Dra. Diana Correa",
    lugar: "Santa Ana | Hospital La Católica",
    direccion: "Dra. Piel",
    telefono: "+506 6465-0496",
    whatsapp: "https://wa.me/50664650496",
    instagram: "https://www.instagram.com/drapielcr/",
    foto: diana,
    producto: "MELINE",
    tipo: "Insumo",
  },
//PBSERUM HA
  {
    id: 95,
    nombre: "Dr. Miguel Ángel Chavarría",
    lugar: "San Rafael de Escazú",
    direccion: "Face&Body Care Center",
    telefono: "+506 8467-4545",
    whatsapp: "https://wa.me/50684674545",
    instagram: "https://www.instagram.com/faceandbodycr/",
    foto: miguel,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
  {
    id: 96,
    nombre: "Dra. Isabel Morelli",
    lugar: "Torre Médica Momentum, Escazú",
    direccion: "IKIGAI",
    telefono: "+506 8650-9119",
    whatsapp: "https://wa.me/50686509119",
    instagram: "https://www.instagram.com/ikigai_by_draisamorelli/",
    foto: isabel,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
  {
    id: 97,
    nombre: "Dr. Armando Bolaños León",
    lugar: "San Pablo, Heredia",
    direccion: "Clínica Dr. Bolaños León",
    telefono: "+506 8828-0588",
    whatsapp: "https://wa.me/50688280588",
    instagram: "https://www.instagram.com/dr.bolanos.leon/",
    foto: bolanos,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
  {
    id: 98,
    nombre: "Dra. Diana Correa",
    lugar: "Santa Ana | Hospital La Católica",
    direccion: "Dra. Piel",
    telefono: "+506 6465-0496",
    whatsapp: "https://wa.me/50664650496",
    instagram: "https://www.instagram.com/drapielcr/",
    foto: diana,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
  {
    id: 99,
    nombre: "Dr. Carlos Bravo",
    lugar: "Barrio Otoya, San José",
    direccion: "Dermatología Integral",
    telefono: "+506 8728-0596",
    whatsapp: "https://wa.me/50687280596",
    instagram: "https://www.instagram.com/dermatologiaintegralcr/",
    foto: carlos,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
  {
    id: 100,
    nombre: "Dra. Stephanie Acuña",
    lugar: "Curridabat",
    direccion: "Clínica Breathe",
    telefono: "+506 6023-1924",
    whatsapp: "https://wa.me/50660231924",
    instagram: "https://www.instagram.com/dra.stephanieacuna/",
    foto: stephanie,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
  {
    id: 101,
    nombre: "Dra. Madeline Espinoza",
    lugar: "Rohrmoser, San José",
    direccion: "Made For You Medical Beauty",
    telefono: "+506 6007-4169",
    whatsapp: "https://wa.me/50660074169",
    instagram: "https://www.instagram.com/mfymedicalbeauty/",
    foto: madeline,
    producto: "PBSERUM HA",
    tipo: "Insumo",
  },
//SMARTKER
  {
    id: 102,
    nombre: "Dra. Stephanie Acuña",
    lugar: "Curridabat",
    direccion: "Clínica Breathe",
    telefono: "+506 6023-1924",
    whatsapp: "https://wa.me/50660231924",
    instagram: "https://www.instagram.com/dra.stephanieacuna/",
    foto: stephanie,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
  {
    id: 103,
    nombre: "Dr. Juan José Hernández",
    lugar: "Sabana Norte | Guápiles",
    direccion: "FullFace Costa Rica",
    telefono: "+506 7032-1391",
    whatsapp: "https://wa.me/50670321391",
    instagram: "https://www.instagram.com/fullfacecostari/",
    foto: juanjose,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
  {
    id: 104,
    nombre: "Dra. Angie Pérez",
    lugar: "Sabana",
    direccion: "Centro Médico Bioneural",
    telefono: "+506 6044-4027",
    whatsapp: "https://wa.me/50660444027",
    instagram: "",
    foto: doctor,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
  {
    id: 105,
    nombre: "Dra. Catalina Araya",
    lugar: "Heredia",
    direccion: "Glow Skin Center",
    telefono: "+506 7205-4650",
    whatsapp: "https://wa.me/50672054650",
    instagram: "https://www.instagram.com/glow.skincentercr/",
    foto: catalina,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
  {
    id: 106,
    nombre: "Dra. Jaghna Cordero",
    lugar: "Plaza Real Alajuela",
    direccion: "Clínica Integral Cordero",
    telefono: "+506 7162-5609",
    whatsapp: "https://wa.me/50671625609",
    instagram: "https://www.instagram.com/clinicaintegralcordero/",
    foto: jaghna,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
  {
    id: 107,
    nombre: "Dra. Nekisha Campbell",
    lugar: "Barrio Otoya, San José",
    direccion: "Clínica Campbell",
    telefono: "+506 8728-0596",
    whatsapp: "https://wa.me/50687280596",
    instagram: "https://www.instagram.com/dermatologiaintegralcr/",
    foto: nekisha,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
  {
    id: 108,
    nombre: "Dra. Ana Lucía Pineda",
    lugar: "San José, San José",
    direccion: "Medible Clinic",
    telefono: "+506 6395-5721",
    whatsapp: "https://wa.me/50663955721",
    instagram: "https://www.instagram.com/medibel_clinic/",
    foto: analucia,
    producto: "SMARTKER",
    tipo: "Insumo",
  },
//GOURI
{
  id: 109,
  nombre: "Dr. Armando Bolaños León",
  lugar: "San Pablo, Heredia",
  direccion: "Clínica Dr. Bolaños León",
  telefono: "+506 8828-0588",
  whatsapp: "https://wa.me/50688280588",
  instagram: "https://www.instagram.com/dr.bolanos.leon/",
  foto: bolanos,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 110,
  nombre: "Dr. Luis Santos",
  lugar: "Ofiplaza del Este, San Pedro",
  direccion: "Dr. Santos Cosmetic",
  telefono: "+506 7132-9559",
  whatsapp: "https://wa.me/50671329559",
  instagram: "https://www.instagram.com/drsantoscr/",
  foto: luis,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 111,
  nombre: "Dra. Diana Correa",
  lugar: "Santa Ana | Hospital La Católica",
  direccion: "Dra. Piel",
  telefono: "+506 6465-0496",
  whatsapp: "https://wa.me/50664650496",
  instagram: "https://www.instagram.com/drapielcr/",
  foto: diana,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 112,
  nombre: "Dr. Andrés Zarnowski",
  lugar: "Santa Ana, Lindora",
  direccion: "Médica Health and Aesthetics | Medicina Integral",
  telefono: "+506 8340-7020",
  whatsapp: "https://wa.me/50683407020",
  instagram: "https://www.instagram.com/medical__cr/",
  foto: andresZ,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 113,
  nombre: "Dra. Ángela Vargas",
  lugar: "Sabana Norte, San José",
  direccion: "Centro Piel y Salud",
  telefono: "+506 8358-6375",
  whatsapp: "https://wa.me/50683586375",
  instagram: "https://www.instagram.com/centropielysalud_/",
  foto: angela,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 114,
  nombre: "Dra. Daniela Vargas",
  lugar: "CMI | Escazú",
  direccion: "The Clinic by Dra. Daniela Vargas",
  telefono: "+506 4052-5400",
  whatsapp: "https://wa.me/50640525400",
  instagram: "https://www.instagram.com/the_clinic_cr/",
  foto: daniela,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 115,
  nombre: "Dr. Roberto Valdivia",
  lugar: "Plaza Obelisco, Escazú",
  direccion: "Doctor Valdivia Sing Láser y Medicina Estética",
  telefono: "+506 6170-4874",
  whatsapp: "https://wa.me/50661704874",
  instagram: "https://www.instagram.com/dr.valdiviasing/",
  foto: robertoV,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 116,
  nombre: "Dra. Michelle Morejón",
  lugar: "San Pedro, San José",
  direccion: "MK Aesthetic",
  telefono: "+506 8704-2626",
  whatsapp: "https://wa.me/50687042626",
  instagram: "https://www.instagram.com/dra.morejon/",
  foto: michelle,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 117,
  nombre: "Doctores Hidalgo",
  lugar: "San Pedro, Montes de Oca",
  direccion: "Cenderma",
  telefono: "+506 8842-0244",
  whatsapp: "https://wa.me/50688420244",
  instagram: "https://www.instagram.com/cendermadrshidalgo/",
  foto: hidalgo,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 118,
  nombre: "Dra. Milagros González",
  lugar: "Plaza Montescazú, Escazú",
  direccion: "Regenerate Clinic",
  telefono: "+506 8754-7798",
  whatsapp: "https://wa.me/50687547798",
  instagram: "https://www.instagram.com/regenerate.clinic/",
  foto: milagros,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 119,
  nombre: "Dra. Herin Rojas",
  lugar: "Escazú | Esparza | Puriscal",
  direccion: "Facial Beauty",
  telefono: "+506 8894-9926",
  whatsapp: "https://wa.me/50688949926",
  instagram: "https://www.instagram.com/dra.facialbeauty/",
  foto: herin,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 120,
  nombre: "Dra. Katherine Farguharson",
  lugar: "Pinares, Curridabat | Heredia",
  direccion: "Consulta Privada",
  telefono: "+506 4700-4038 / +506 8861-5680",
  whatsapp: "https://wa.me/50647004038",
  instagram: "https://www.instagram.com/dra_farguharson/",
  foto: katherineF,
  producto: "GOURI",
  tipo: "Insumo",
},
{
  id: 121,
  nombre: "Dr. Edward Castro",
  lugar: "Sabana Norte, San José",
  direccion: "Beyond Laser Skin Center",
  telefono: "+506 7133-6006",
  whatsapp: "https://wa.me/50671336006",
  instagram: "https://www.instagram.com/beyond.laserskincenter/",
  foto: edward,
  producto: "GOURI",
  tipo: "Insumo",
},
];